/**
 * IXD 편집기 페이지 스토어 Provider
 */

import { useRef } from "react";
import { createIxdEditorStore, IxdEditorStoreContext } from "./store";
import { EditSessionStoreProvider } from "@/hooks/ixd-edit-session";

export const IxdEditorStoreProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const storeRef = useRef<ReturnType<typeof createIxdEditorStore> | null>(null);
  if (!storeRef.current) {
    storeRef.current = createIxdEditorStore();
  }
  const store = storeRef.current;

  return (
    <IxdEditorStoreContext.Provider value={store}>
      <EditSessionStoreProvider>{children}</EditSessionStoreProvider>
    </IxdEditorStoreContext.Provider>
  );
};
